import React, { useRef } from 'react';
import ChatContainer from './ChatContainer';
import ContactMe from './ContactMe';
import Projects from './Projects';
import './styles.css';
import profileImage from './assets/profile.jpg';

const STATS = [
  { number: '9+', label: 'Years Experience' },
  { number: '3', label: 'Fortune 500 Companies' },
  { number: '160K+', label: 'Users Served' },
  { number: '99.9%', label: 'SLA Maintained' },
];

function App() {
  const chatRef = useRef(null);

  const scrollToChat = () => {
    chatRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="app">
      <section className="hero">
        <div className="hero-inner">
          <div className="profile-image-container">
            <img src={profileImage} alt="Satyarth" className="profile-image" />
            <span className="availability-dot" title="Open to opportunities" />
          </div>
          <h1 className="hero-name">Satyarth P.</h1>
          <p className="hero-role">Lead AI &amp; Machine Learning Engineer</p>
          <p className="hero-tagline">
            I build AI systems that turn complex data into real-world impact — from enterprise
            GenAI platforms to production ML pipelines serving hundreds of thousands.
          </p>
          <div className="hero-ctas">
            <button className="btn-primary" onClick={scrollToChat}>
              Chat with my AI &darr;
            </button>
            <a
              className="btn-secondary"
              href="mailto:psatyarthaprakash@gmail.com"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </section>

      <section className="stats-strip">
        {STATS.map((s) => (
          <div key={s.label} className="stat-item">
            <div className="stat-number">{s.number}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </section>

      <main className="main-content">
        <Projects />

        <div ref={chatRef} className="chat-section">
          <h2 className="section-title">Ask My AI</h2>
          <p className="section-subtitle">
            Get instant answers about my experience, projects, and more.
          </p>
          <ChatContainer />
        </div>
      </main>

      <ContactMe />
    </div>
  );
}

export default App;
